import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }       from '@ngx-translate/core';

import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-customer-resolve-matches',
  template: require('./customer-resolve-matches.component.html')
})
export class CustomerResolveMatchesComponent implements OnInit {
  @Input() customer: any;
  @Input() matches: Array<any>;

  selectedItems: Array<any> = [];
  tableSettings: any;

  constructor (
    public activeModal: NgbActiveModal,
    private messagesService: MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.tableSettings = {
      columns: [
        {
          field : 'display_name',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME') }
        },
        {
          field : 'phone',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE') },
          pipe  : 'phone'
        },
        {
          field : 'mobile',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE') },
          pipe  : 'mobilePhone'
        },
        {
          field : 'email',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL') }
        },
        {
          field : 'address1',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS') }
        },
        {
          field : 'address2',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.ADDRESS') }
        },
        {
          field : 'suburb',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.SUBURB') }
        },
        {
          field : 'state',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.STATE') }
        },
        {
          field : 'postcode',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.POSTCODE') }
        }
      ],
      empty: {
        text: this.translateService.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: { enabled: true },
        select   : { enabled: true }
      },
      sorting: {
        enabled: false
      }
    };
  }

  confirm (): void {
    this.customer.saveMatch(this.selectedItems[0])
      .then(() => this.activeModal.close())
      .catch((err: any) => this.messagesService.error(err));
  }

  selectMatch (): void {
    this.selectedItems = this.matches.filter((match: any) => match.selected);
  }
}
